export const actionBarFontSizeVariants = {
  underVideo: "12px",
  onModal: "16px",
  videoItem: "10px",
};
